module.exports = __webpack_public_path__ + "img/icon-credit-card@3x.8a97ebc4.png";